// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grd {
  --grd-rule: #cbd5e1;
  --grd-ink: #0f172a;
  --grd-muted: #64748b;
  --grd-band: #f8fafc;
  --grd-paper: #ffffff;
  --grd-body-hatch: repeating-linear-gradient(
    -45deg,
    #f1f5f9,
    #f1f5f9 6px,
    #e2e8f0 6px,
    #e2e8f0 7px
  );
}

.grd__pagehead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.grd__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--grd-ink);
  line-height: 1.25;
}

.grd__subtitle {
  margin: 4px 0 0;
  font-size: 0.8125rem;
  color: var(--grd-muted);
  max-width: 46rem;
}

.grd__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.grd__meta {
  font-size: 0.75rem;
  color: var(--grd-muted);
  white-space: nowrap;
}

.grd__banner {
  margin: 0 0 12px;
  padding: 8px 10px;
  border: 1px solid #99f6e4;
  background: #f0fdfa;
  color: #115e59;
  font-size: 0.75rem;
  border-radius: 8px;
}

.grd__modes {
  display: inline-flex;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.grd__mode {
  height: 32px;
  padding: 0 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #475569;
  background: #fff;
  border: 0;
  cursor: pointer;
}

.grd__mode.is-active {
  background: #0f766e;
  color: #fff;
}

.grd__canvas-wrap,
.grd__preview-wrap {
  display: grid;
  gap: 12px;
}

.grd-paper {
  background: var(--grd-paper);
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  overflow: hidden;
}

.grd-band {
  border-bottom: 1px solid var(--grd-rule);
}

.grd-band:last-child {
  border-bottom: 0;
}

.grd-band__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 10px;
  background: #0b1f33;
  color: #e2e8f0;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.grd-band__bar--body {
  background: #334155;
}

.grd-band__hint {
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  color: #94a3b8;
}

.grd-band__editor .grd-editor {
  border: 0;
  border-radius: 0;
}

.grd-body {
  min-height: 148px;
  padding: 16px 18px;
  background-image: var(--grd-body-hatch);
  color: #64748b;
  font-size: 0.8125rem;
  line-height: 1.45;
}

.grd-body strong {
  color: #334155;
}

.grd-editor {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #fff;
}

.grd-editor__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.grd-editor__sep {
  width: 1px;
  height: 18px;
  margin: 0 4px;
  background: #e2e8f0;
}

.grd-editor__select {
  height: 28px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  font-size: 0.75rem;
  color: #334155;
  padding: 0 6px;
}

.grd-editor__surface {
  min-height: 72px;
  padding: 8px 12px;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--grd-ink);
  outline: none;
}

.grd-editor__surface--first {
  min-height: 132px;
}

.grd-editor__surface--subsequent {
  min-height: 64px;
}

.grd-editor__surface--footer {
  min-height: 72px;
}

.grd-editor__surface:empty:before {
  content: attr(data-placeholder);
  color: #94a3b8;
  pointer-events: none;
}

.grd-ph {
  display: inline-block;
  margin: 0 1px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ccfbf1;
  color: #115e59;
  border: 1px solid #5eead4;
  font-family: "IBM Plex Mono", ui-monospace, monospace;
  font-size: 0.6875rem;
  font-weight: 500;
  line-height: 1.5;
  vertical-align: baseline;
  -webkit-user-select: all;
          user-select: all;
}

.grd-logo {
  display: inline-block;
  max-height: 48px;
  max-width: 180px;
  vertical-align: middle;
}

.grd-preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.grd-page {
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  min-height: 420px;
  padding: 18px 20px 14px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  font-size: 0.8125rem;
  color: #0f172a;
}

.grd-page__label {
  margin: 0 0 10px;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.grd-page__header,
.grd-page__footer {
  color: #0f172a;
}

.grd-page__header {
  padding-bottom: 8px;
  border-bottom: 1px solid #cbd5e1;
}

.grd-page__header--compact {
  font-size: 0.75rem;
}

.grd-page__body {
  flex: 1 1;
  margin: 12px 0;
  color: #475569;
  line-height: 1.5;
}

.grd-page__footer {
  padding-top: 8px;
  border-top: 1px solid #cbd5e1;
  font-size: 0.75rem;
  color: #475569;
}

.grd-page .grd-logo {
  margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-report-designer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB;;;;;;GAMC;AACH;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qDAAqD;EACrD,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".grd {\n  --grd-rule: #cbd5e1;\n  --grd-ink: #0f172a;\n  --grd-muted: #64748b;\n  --grd-band: #f8fafc;\n  --grd-paper: #ffffff;\n  --grd-body-hatch: repeating-linear-gradient(\n    -45deg,\n    #f1f5f9,\n    #f1f5f9 6px,\n    #e2e8f0 6px,\n    #e2e8f0 7px\n  );\n}\n\n.grd__pagehead {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.grd__title {\n  margin: 0;\n  font-size: 1.375rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--grd-ink);\n  line-height: 1.25;\n}\n\n.grd__subtitle {\n  margin: 4px 0 0;\n  font-size: 0.8125rem;\n  color: var(--grd-muted);\n  max-width: 46rem;\n}\n\n.grd__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.grd__meta {\n  font-size: 0.75rem;\n  color: var(--grd-muted);\n  white-space: nowrap;\n}\n\n.grd__banner {\n  margin: 0 0 12px;\n  padding: 8px 10px;\n  border: 1px solid #99f6e4;\n  background: #f0fdfa;\n  color: #115e59;\n  font-size: 0.75rem;\n  border-radius: 8px;\n}\n\n.grd__modes {\n  display: inline-flex;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.grd__mode {\n  height: 32px;\n  padding: 0 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #475569;\n  background: #fff;\n  border: 0;\n  cursor: pointer;\n}\n\n.grd__mode.is-active {\n  background: #0f766e;\n  color: #fff;\n}\n\n.grd__canvas-wrap,\n.grd__preview-wrap {\n  display: grid;\n  gap: 12px;\n}\n\n.grd-paper {\n  background: var(--grd-paper);\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n}\n\n.grd-band {\n  border-bottom: 1px solid var(--grd-rule);\n}\n\n.grd-band:last-child {\n  border-bottom: 0;\n}\n\n.grd-band__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 4px 10px;\n  background: #0b1f33;\n  color: #e2e8f0;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.grd-band__bar--body {\n  background: #334155;\n}\n\n.grd-band__hint {\n  font-weight: 400;\n  letter-spacing: 0;\n  text-transform: none;\n  color: #94a3b8;\n}\n\n.grd-band__editor .grd-editor {\n  border: 0;\n  border-radius: 0;\n}\n\n.grd-body {\n  min-height: 148px;\n  padding: 16px 18px;\n  background-image: var(--grd-body-hatch);\n  color: #64748b;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n}\n\n.grd-body strong {\n  color: #334155;\n}\n\n.grd-editor {\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n}\n\n.grd-editor__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 2px;\n  padding: 4px 6px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.grd-editor__sep {\n  width: 1px;\n  height: 18px;\n  margin: 0 4px;\n  background: #e2e8f0;\n}\n\n.grd-editor__select {\n  height: 28px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.75rem;\n  color: #334155;\n  padding: 0 6px;\n}\n\n.grd-editor__surface {\n  min-height: 72px;\n  padding: 8px 12px;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--grd-ink);\n  outline: none;\n}\n\n.grd-editor__surface--first {\n  min-height: 132px;\n}\n\n.grd-editor__surface--subsequent {\n  min-height: 64px;\n}\n\n.grd-editor__surface--footer {\n  min-height: 72px;\n}\n\n.grd-editor__surface:empty:before {\n  content: attr(data-placeholder);\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.grd-ph {\n  display: inline-block;\n  margin: 0 1px;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #ccfbf1;\n  color: #115e59;\n  border: 1px solid #5eead4;\n  font-family: \"IBM Plex Mono\", ui-monospace, monospace;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  line-height: 1.5;\n  vertical-align: baseline;\n  user-select: all;\n}\n\n.grd-logo {\n  display: inline-block;\n  max-height: 48px;\n  max-width: 180px;\n  vertical-align: middle;\n}\n\n.grd-preview-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.grd-page {\n  background: #fff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  min-height: 420px;\n  padding: 18px 20px 14px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8125rem;\n  color: #0f172a;\n}\n\n.grd-page__label {\n  margin: 0 0 10px;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.grd-page__header,\n.grd-page__footer {\n  color: #0f172a;\n}\n\n.grd-page__header {\n  padding-bottom: 8px;\n  border-bottom: 1px solid #cbd5e1;\n}\n\n.grd-page__header--compact {\n  font-size: 0.75rem;\n}\n\n.grd-page__body {\n  flex: 1;\n  margin: 12px 0;\n  color: #475569;\n  line-height: 1.5;\n}\n\n.grd-page__footer {\n  padding-top: 8px;\n  border-top: 1px solid #cbd5e1;\n  font-size: 0.75rem;\n  color: #475569;\n}\n\n.grd-page .grd-logo {\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
